import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

// Global error handlers to catch crashes before React mounts
window.addEventListener('error', (e) => {
  const root = document.getElementById('root');
  if (root && root.children.length === 0) {
    root.innerHTML = '<div style="padding:2rem;font-family:monospace;font-size:14px;color:#333"><h2 style="color:red">App Crash Detected</h2><pre style="white-space:pre-wrap;word-break:break-all">' +
      (e.error ? e.error.stack || e.error.toString() : e.message) + '</pre></div>';
  }
});
window.addEventListener('unhandledrejection', (e) => {
  const root = document.getElementById('root');
  if (root && root.children.length === 0) {
    root.innerHTML = '<div style="padding:2rem;font-family:monospace;font-size:14px;color:#333"><h2 style="color:red">Unhandled Promise Rejection</h2><pre style="white-space:pre-wrap;word-break:break-all">' +
      (e.reason && e.reason.stack ? e.reason.stack : String(e.reason)) + '</pre></div>';
  }
});

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);

// Unregister service worker to clear stale caches causing white screen
serviceWorkerRegistration.unregister();
